// Shared CDN helpers — single source for Discord avatar/icon URLs.
// Backend owns raw hash; frontend/backend derive the CDN URL identically.

export function avatarCdnUrl(userId: string, hash: string, size = 64): string {
  if (hash === "") return "";
  if (hash.startsWith("http://") || hash.startsWith("https://")) return hash;
  const ext = hash.startsWith("a_") ? "gif" : "webp";
  return `https://cdn.discordapp.com/avatars/${userId}/${hash}.${ext}?size=${size}`;
}

export function guildIconCdnUrl(guildId: string, hash: string | null, size = 64): string | null {
  if (hash === null || hash === "") return null;
  if (hash.startsWith("http://") || hash.startsWith("https://")) return hash;
  const ext = hash.startsWith("a_") ? "gif" : "webp";
  return `https://cdn.discordapp.com/icons/${guildId}/${hash}.${ext}?size=${size}`;
}


